import type { SVGProps } from 'react'

import { CustomIconProps } from '@/shared/ui/icon-template'

export const WalletSvg = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
			<path
				d="M5 33V8C5 6.34315 6.34315 5 8 5H30V33C30 34.1046 29.1046 35 28 35H7C5.89543 35 5 34.1046 5 33Z"
				fill="url(#paint0_linear_19781_20857)"
			/>
			<path
				d="M5 35V13C5 11.3431 6.34315 10 8 10H33C34.1046 10 35 10.8954 35 12V33C35 34.1046 34.1046 35 33 35H5Z"
				fill="#4A4A4A"
			/>
			<path
				d="M29.168 20C30.5487 20 31.668 21.1193 31.668 22.5C31.668 23.8807 30.5487 25 29.168 25C27.7872 25 26.668 23.8807 26.668 22.5C26.668 21.1193 27.7872 20 29.168 20Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_19781_20857"
					x1="3.75003"
					y1="36.6667"
					x2="3.75003"
					y2="3.33334"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5C90FC" />
					<stop offset="1" stopColor="#B7D2FF" />
				</linearGradient>
			</defs>
		</svg>
	)
}
